<template>
 <div>
  <GridIndex></GridIndex>
 </div>
</template>

<script lang = "ts" >
import GridIndex from "./components/GridPesquisa.vue";
import {defineComponent} from "vue";
export default defineComponent({
 name: "BibExemplarPesquisa",
 components: { GridIndex },
});
</script>
